import {
  fetchUserHoldingsKite,
  generateSmallCaseTransaction,
  fetchUserHoldingsSmallcase,
} from '../../api';

const onKiteSync = async (pfId, onSync, onExistingKitePortfolio) => {
  try {
    //fetch holdings
    const res = await fetchUserHoldingsKite(pfId);
    onSync();
    return;
  } catch (error) {
    if (error.response && error.response.data.redirect_url) {
      const kitewin = window.open(error.response.data.redirect_url, '_blank');
      window.addEventListener('message', (e) => {
        if (
          e.origin != window.location.origin ||
          typeof e.data != 'string' ||
          !JSON.parse(e.data).source === 'sync_capture'
        )
          return;
        const status = JSON.parse(e.data).status;
        if (status === 'success') {
          onSync();
        }
        if (status === 'promt_portfolio_selection') {
          const pfId = JSON.parse(e.data).pfId;
          if (onExistingKitePortfolio) onExistingKitePortfolio(pfId);
        }
        kitewin.close();
        return;
      });
      return;
    }
    console.log(error);
  }
};

const onBrokerSync = async (pfId, onSync) => {
  try {
    // get jwt token
    const res = await generateSmallCaseTransaction(pfId);
    window.django.smallcase = {};
    window.django.smallcase.token = res.data.token;
    window.django.smallcase.tx_id = res.data.tx_id;
    const gatewayInstance = new window.scDK({
      // ! Use valid gateway name here
      gateway: 'tijori',
      /*
       * ! Use valid auth token
       * Details - https://developers.gateway.smallcase.com/docs/kickstart-integration#jwt--json-web-tokens
       */
      smallcaseAuthToken: window.django.smallcase.token,
      config: {
        // Should allow after market orders?
        amo: true,
      },
    });
    gatewayInstance.init({
      smallcaseAuthToken: window.django.smallcase.token,
    });
    // trigger tx
    const tx = await gatewayInstance.triggerTransaction({
      transactionId: window.django.smallcase.tx_id,
      brokers: [
        'aliceblue',
        'angelbroking',
        'dhan',
        'fivepaisa',
        'groww',
        'motilal',
        'trustline',
        'upstox',
      ],
    });
    //fetch holdings
    const holdings = await fetchUserHoldingsSmallcase(
      pfId,
      tx.smallcaseAuthToken,
    );
    onSync();
    return;
  } catch (error) {
    if (error.message && error.message === 'user_cancelled') {
      return;
    }
    console.log(error);
  }
};

export { onKiteSync, onBrokerSync };
